import { Badge } from 'lift-ui';
import type { BadgeProps } from 'lift-ui';
import type { JobStatus } from '../types';

const STATUS_VARIANT: Record<JobStatus, BadgeProps['variant']> = {
  pending: 'blueLight',
  failed: 'danger',
  in_progress: 'blue',
  blocked: 'warning',
  scheduled: 'lavenderLight',
  finished: 'success',
};

export const STATUS_LABEL: Record<JobStatus, string> = {
  pending: 'Pending',
  failed: 'Failed',
  in_progress: 'In progress',
  blocked: 'Blocked',
  scheduled: 'Scheduled',
  finished: 'Finished',
};

export const JobStatusBadge = ({ status }: { status: JobStatus | null }) => {
  if (!status) return <span className="text-muted-foreground">—</span>;

  return <Badge variant={STATUS_VARIANT[status]}>{STATUS_LABEL[status]}</Badge>;
};

export default JobStatusBadge;
